import React from "react";
import { Spin } from "antd";
import { inject, observer } from "mobx-react";

import "./style/renderExpandedRow.scss";

@inject("languageStore", "authStore", "gameStore")
@observer
class RenderExpandedRow extends React.Component {
  state = {
    duty: [],
    requirement: [],
    isLoading: true,
  };

  componentDidMount() {
    this.fetchJobDetail();
  }

  fetchJobDetail = async () => {
    const res = await this.props.gameStore.fetchJobDetail(
      this.props.record.positionId
    );
    if (res && res.status === 0) {
      const { duty, requirement } = res;

      this.setState({
        duty: duty.split("\n"),
        requirement: requirement.split("\n"),
        isLoading: false,
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  renderInfoList = (list) =>
    list.map((item, index) => {
      if (/^-/.test(item)) {
        return (
          <p className="renderExpandedRow__title--itemIn" key={index}>
            {item}
          </p>
        );
      }
      return (
        <p className="renderExpandedRow__title--item" key={index}>
          {item}
        </p>
      );
    });

  emptyDom = (<p className="renderExpandedRow__title--item">{"暂无"}</p>);

  render() {
    const { duty, requirement, isLoading } = this.state;

    if (isLoading) {
      return (
        <div className="renderExpandedRow--loading">
          <Spin />
        </div>
      );
    }

    return (
      <div className="renderExpandedRow">
        <div className="renderExpandedRow__title">{"工作职责"}</div>
        {duty.length > 0 ? this.renderInfoList(duty) : this.emptyDom}
        <div className="renderExpandedRow__title">{"任职要求"}</div>
        {requirement.length > 0
          ? this.renderInfoList(requirement)
          : this.emptyDom}
      </div>
    );
  }
}

export default (record, index, indent, expanded) => {
  return (
    <RenderExpandedRow
      key={record.positionId}
      record={record}
      index={index}
      indent={indent}
      expanded={expanded}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/formList/gameForm/jobSelect/renderExpandedRow.js